module.exports = __webpack_public_path__ + "static/media/study_area.5f8ed2e8.svg";